import { PAGE_NAME } from '../../events';

/**
 * Builds source info object for machine translation BI reporting.
 *
 * @param {string} componentName - source component name initiating the translation
 * @param {number} gigId - gig id
 * @param {Object=} user - user object
 */
export const buildSourceInfo = ({ componentName, gigId, user = {} }) => ({
    name: PAGE_NAME,
    component: {
        name: componentName
    },
    gig: {
        id: gigId
    },
    user
});
